import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ChatIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 1.73053C4.13401 1.73053 1 3.99253 1 7.73053C1 9.56264 1.75288 11.0401 2.97581 12.0706C2.22526 14.5106 2.07619 15.7305 2.52874 15.7305C2.93754 15.7305 3.96564 14.9606 5.61306 13.4207C6.35802 13.6242 7.16181 13.7305 8 13.7305C11.866 13.7305 15 11.3983 15 7.73053C15 4.0627 11.866 1.73053 8 1.73053Z"
		/>
	</svg>
))
